import { AuthState } from '@okta/okta-auth-js';

import { RefFuturesContractsSummaries } from '../../services/backend/RefFuturesContractsSummaries';
import { useBaseApiClient } from '../useBaseApiClient';

export const useRefFuturesContractsSummaries: () => RefFuturesContractsSummaries<AuthState> =
  () => {
    return useBaseApiClient(RefFuturesContractsSummaries);
  };
